import { Check, PanelRight, User } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useStore } from '../../store/useStore';

export default function SettingsView() {
  const { currentUser, showCrm, wsStatus, updateUserSettings, setCrmPreference } = useStore();
  const [form, setForm] = useState(currentUser);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    setForm(currentUser);
  }, [currentUser]);

  const handleSave = () => {
    updateUserSettings({
      name: form.name.trim() || currentUser.name,
      initials: form.initials.trim() || currentUser.initials,
      role: form.role.trim() || currentUser.role,
    });
    setSaved(true);
    window.setTimeout(() => setSaved(false), 1200);
  };

  return (
    <main className="settings-view">
      <div className="settings-header">
        <div>
          <div className="settings-title">设置</div>
          <div className="settings-subtitle">个人资料和工作台偏好</div>
        </div>
      </div>

      <div className="settings-content">
        <section className="settings-panel">
          <div className="settings-panel-title">
            <User size={15} />
            <span>个人资料</span>
          </div>
          <div className="settings-form">
            <label>
              <span>姓名</span>
              <input value={form.name || ''} onChange={event => setForm({ ...form, name: event.target.value })} />
            </label>
            <label>
              <span>头像缩写</span>
              <input maxLength={2} value={form.initials || ''} onChange={event => setForm({ ...form, initials: event.target.value })} />
            </label>
            <label>
              <span>角色</span>
              <input value={form.role || ''} onChange={event => setForm({ ...form, role: event.target.value })} />
            </label>
          </div>
          <button className="settings-save" onClick={handleSave}>
            <Check size={15} />
            <span>{saved ? '已保存' : '保存'}</span>
          </button>
        </section>

        <section className="settings-panel">
          <div className="settings-panel-title">
            <PanelRight size={15} />
            <span>工作台</span>
          </div>
          <div className="settings-row">
            <div>
              <div className="settings-row-title">默认显示 CRM 侧栏</div>
              <div className="settings-row-desc">打开会话时保留右侧客户资料面板</div>
            </div>
            <button className={`toggle-switch ${showCrm ? 'on' : ''}`} onClick={() => setCrmPreference(!showCrm)}>
              <span />
            </button>
          </div>
          <div className="settings-row">
            <div>
              <div className="settings-row-title">实时连接</div>
              <div className="settings-row-desc">当前 WebSocket 状态：{wsStatus}</div>
            </div>
            <span className={`status-pill ${wsStatus === 'connected' ? 'ok' : ''}`}>
              {wsStatus === 'connected' ? '已连接' : '未连接'}
            </span>
          </div>
        </section>
      </div>
    </main>
  );
}
